/**
 * Case Studies slider: native horizontal scroll with snap points. The arrows scroll one card,
 * disable at the ends, and hide when everything fits. The right fade shows while more is to the right.
 */
(() => {
  const init = (root) => {
    const track = root.querySelector('[data-case-studies-track]');
    const controls = root.querySelector('[data-case-studies-controls]');
    const prev = root.querySelector('[data-case-studies-prev]');
    const next = root.querySelector('[data-case-studies-next]');

    if (!track || !controls || !prev || !next) {
      return;
    }

    const step = () => {
      const card = track.firstElementChild;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return card ? card.getBoundingClientRect().width + gap : track.clientWidth;
    };

    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      const atStart = track.scrollLeft <= 1;
      const atEnd = track.scrollLeft >= max - 1;
      controls.hidden = max <= 1;
      prev.disabled = atStart;
      next.disabled = atEnd;
      root.classList.toggle('has-more', !atEnd);
    };

    prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  };

  const boot = () => document.querySelectorAll('[data-case-studies]').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
